import React from "react";
import { classNames } from "../../helpers";
import { Apple, Play } from "lucide-react";
// import apple_play_store from "../../assets/appstore-btn.png";
// import google_play_store from "../../assets/playstore-btn.png";
import apple_play_store from "../../assets/apple-play-store.svg";
import google_play_store from "../../assets/google-playstore-button.svg";


export default function TwStoreButton(props) {
  const { children, className = "", error = false, url = "#", size = "md", btnType = "google" } = props

  return btnType == "google" ? <GooglePlayButton url={url} size={size} /> :
    <AppleButton url={url} size={size} />;
  ;
}

export function GooglePlayButton({ url = "#", size = "md" }) {
  return (
    <StoreButton
      href={url}
      labelTop="Get it on"
      labelBottom="Google Play"
      // icon={
      //   <svg
      //     xmlns="http://www.w3.org/2000/svg"
      //     viewBox="0 0 32 32"
      //     className="h-6 w-6 text-black dark:text-white"
      //     fill="currentColor"
      //   >
      //     <path d="M17,14.5l4.2-4.5L4.9,1.2C4.8,1.1,4.6,1.1,4.3,1L17,14.5z"></path>
      //     <path d="M23,21l5.9-3.2c0.7-0.4,1.1-1,1.1-1.8s-0.4-1.5-1.1-1.8L23,11l-4.7,5L23,21z"></path>
      //     <path d="M2.4,1.9C2.1,2.2,2,2.6,2,3V29c0,0.4,0.1,0.8,0.4,1.2L15.6,16L2.4,1.9z"></path>
      //     <path d="M17,17.5L4.3,31c0.2,0,0.4-0.1,0.6-0.2L21.2,22L17,17.5z"></path>
      //   </svg>
      // }
      icon={
        <img 
        className="w-44"
        alt="Play Store Btn"
          src={google_play_store}></img>
      }
      sizeKey={size}
    />
  );
}

export function AppleButton({ url = "#", size = "md" }) {
  return (
    <StoreButton
      href={url}
      labelTop="Download on the"
      labelBottom="App Store"
      // icon={
      //   <svg
      //     xmlns="http://www.w3.org/2000/svg"
      //     viewBox="0 0 384 512"
      //     className="h-6 w-6 text-black dark:text-white"
      //     fill="currentColor"
      //   >
      //     <path d="M318.7 268c-.1-35.5 15.7-62.3 48-82.2-18.2-26-45.4-40.2-81.2-42.7-34.2-2.4-71.2 20.1-84.7 20.1-14 0-46.4-19.2-71.9-18.7-52.9.8-109.2 40.4-109.2 119.7 0 23.6 4.4 47.3 13.1 70.9 11.7 30.6 54 105.2 98.1 104 23.1-.5 39.2-16.4 69.1-16.4 29.5 0 43.9 16.4 69.2 16 44.6-.7 82.2-70.2 93.5-100.9-59.2-28.1-45.1-82-44.9-90.8zM251.7 86.4c18.6-22.5 27.2-48.6 24.5-76.4-26.3 1-56.8 18.4-75.3 40.9-16.5 19.4-28.4 46-24.8 73.1 28.7 2.2 57.6-14.2 75.6-37.6z" />
      //   </svg>
      // }
      icon={
        <img 
        className="w-44"
        alt="App Store Btn"
          src={apple_play_store}></img>

      }
      sizeKey={size}
    />
  );
}

export function StoreButton({ href = "#", labelTop = "", labelBottom = "", icon = null, sizeKey = "md" }) {
  const s = sizeMap[sizeKey];
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      // className={`group inline-flex items-center ${s.padY} ${s.padX} ${s.gap}
      //   rounded-2xl border border-black/10 dark:border-white/10
      //   bg-white/90 dark:bg-zinc-900/90 backdrop-blur
      //   shadow-sm hover:shadow transition-shadow
      //   focus:outline-none focus:ring-2 focus:ring-offset-2
      //   focus:ring-black/30 dark:focus:ring-white/30
      //   focus:ring-offset-white dark:focus:ring-offset-zinc-900`}
      className={`group inline-flex items-center`}
    >
      {/* <span className="shrink-0" aria-hidden>
        {icon}
      </span>
      <span className="flex flex-col leading-tight">
        <span className={`font-medium uppercase tracking-wide text-black/60 dark:text-white/60 ${s.textTop}`}>
          {labelTop}
        </span>
        <span className={`font-semibold text-black dark:text-white ${s.textBottom}`}>
          {labelBottom}
        </span>
      </span> */}
      {icon}
    </a>
  );
}

const sizeMap = {
  sm: {
    padY: "py-1.5",
    padX: "px-3",
    textTop: "text-[10px]",
    textBottom: "text-xs",
    icon: 22,
    gap: "gap-2",
  },
  md: {
    padY: "py-2",
    padX: "px-4",
    textTop: "text-[11px]",
    textBottom: "text-sm",
    icon: 28,
    gap: "gap-2.5",
  },
  lg: {
    padY: "py-3",
    padX: "px-5",
    textTop: "text-xs",
    textBottom: "text-base",
    icon: 32,
    gap: "gap-3",
  },
};
